import React from 'react'
import Scrollspy from 'react-scrollspy'
import Scroll from './Scroll'

import { withNamespaces } from 'react-i18next'

const Nav = ({ sticky, t }) => (
  <nav id="nav" className={sticky ? 'alt' : ''}>
    <Scrollspy
      items={['intro', 'first', 'second', 'cta']}
      currentClassName="is-active"
      offset={-300}
    >
      <li>
        <Scroll type="id" element="intro">
          <a href="#">{t('Introduction')}</a>
        </Scroll>
      </li>
      <li>
        <Scroll type="id" element="first">
          <a href="#">{t('Features')}</a>
        </Scroll>
      </li>
      <li>
        <Scroll type="id" element="second">
          <a href="#">{t('Try it out')}</a>
        </Scroll>
      </li>
      <li>
        <Scroll type="id" element="cta">
          <a href="#">{t('About us')}</a>
        </Scroll>
      </li>
    </Scrollspy>
  </nav>
)

export default withNamespaces()(Nav)
